"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matcher = void 0;
var filter_1 = __importDefault(require("../util/filter"));
var data_helpers_1 = require("../util/data-helpers");
function matcher(word, item, textField) {
  if (!word) {
    return function () {
      return true;
    };
  }
  word = word.toLowerCase();
  return function (item) {
    return filter_1.default.startsWith(data_helpers_1.dataText(item, textField).toLowerCase(), word);
  };
}
exports.matcher = matcher;